<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="证照编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入证照编码" v-model="queryParam.licenseCode"></a-input>
                </a-form-item>
              </a-col>

              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>

                </a-col>
              </span>

            </a-row>

          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <!-- 操作按钮区域 -->
      <div class="table-operator" style="margin-top: 5px">
        <!-- <a-button type="primary" @click="searchQuery">查询</a-button> -->
        <!-- <a-button @click="handleAdd" type="primary" icon="plus">添加</a-button> -->
      </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered :rowKey="(record,index)=>{return index}"
            :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
            :pagination="ipagination" :loading="loading"
            @change="handleTableChange" style="word-break: break-all;">
            <span slot="action" slot-scope="text, record">
              <a type="primary" @click="getLicenseProduct(record)">查看商品</a>
            </span>
            <template slot="createTime" slot-scope="createTime">
              <span>{{changetime(createTime)}}</span>
            </template>
            <template slot="licenseType" slot-scope="licenseType">
              <a-tag v-if="licenseType == 0" color="green">经营许可证</a-tag>
            <a-tag v-else-if="licenseType == 1" color="green">生产许可证</a-tag>
            <a-tag v-else-if="licenseType == 2" color="green">产品注册证</a-tag>
            </template>
            <template slot="customPic" slot-scope="text, record">
                <a-popover placement="right" trigger="click">
                    <template slot="content">
                      <img :src="getImgUrl(record.attachment, record.imgLarge)" width="500px" />
                    </template>
                    <div style="width:52px;height:52px;" v-if="record.attachment">
                      <img v-if="record.attachment" :src="getImgUrl(record.attachment, record.imgSmall)" class="item-img" title="查看大图" style="width:100%;height:auto"/>
                    </div>
                </a-popover>
              </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->

        <productLicenseToList ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></productLicenseToList>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
//ledgerAdd
import productLicenseToList from './modules/productLicenseToList'
import { campListMixins } from './mixins/campListMixins'
import { ledgerDelete,ledgerEdit, searchProductList } from '@/api/api'
import JDate from '@/components/jeecg/JDate'
import { getFileAccessHttpUrl } from '@/api/manage'


export default {
  name: 'RetailOutList',
  mixins: [campListMixins],
  components: {

    productLicenseToList,
    JDate,
  },
  data() {
    return {
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      // 查询条件
      queryParam: {


      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 默认列
      columns: [
        { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
//         { title: '状态', dataIndex: 'state',width: 80, align: "center",scopedSlots: { customRender: 'state' } },
        { title: '证照类型', dataIndex: 'licenseType', width: 100, scopedSlots: { customRender: 'licenseType' }, render: (text) => text || "--" },
        { title: '证照编码', dataIndex: 'licenseCode',width: 120, render: (text) => text || "--"},
        { title: '有效期起', dataIndex: 'expirationDate', width: 120, render: (text) => text || "--" },
        { title: '有效期至', dataIndex: 'expirationEndDate', width: 120 ,render: (text) => text || "--" },
        { title: '附件', dataIndex: 'attachment', width: 120 ,render: (text) => text || "--", scopedSlots: { customRender: 'customPic' } },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/sy/material/materialLicence/list',

      },
    }
  },
  computed: {},
  created() {

  },
  methods: {
    async getLicenseProduct(record){
      console.log(record)
      let params = {
        licenceCode : record.licenseCode,
      }
      const res = await searchProductList(params)
      if(res.code == 200 && res.success == true){
        this.$refs.modalForm.initShow(res)
      }
      this.loadData()

    },
    getImgUrl (imgName, type) {
        if (imgName && imgName.split(',')) {
            type = type ? type + '/' : ''
            return getFileAccessHttpUrl('systemConfig/static/' + type + imgName.split(',')[0])
        } else {
            return ''
        }
    },
    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    async handleAudit(record,e) {
      console.log(record,'审核record============')
      let params = {
        uuid : record.uuid,
        state: e
      }
      const res = await ledgerEdit(params)
      this.loadData()
    },
    //handleAuditCancel
    async handleAuditCancel(record,e) {
      console.log(record,'审核record============')
      let params = {
        uuid : record.uuid,
        state: e
      }
      const res = await ledgerEdit(params)
      this.loadData()
    },

    //删除handleDelete
    async handleDelete(record) {
      let params = {
        id : record.uuid
      }
      const res = await ledgerDelete(params)
      if (res.code == 200 && res.success == true) {
        this.$message.success(res.message)
        this.loadData()
      } else {
        this.$message.error(res.message)
      }

    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
/deep/.ant-table-row-cell-break-word:empty:after {
  content: '--';
}
</style>